<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic"
  class="search-input"
  [class.search-input--active]="fc.value"
>
  <button type="button" matPrefix mat-icon-button aria-label="Back" (click)="back()">
    <mat-icon>{{ leftIcon }}</mat-icon>
  </button>
  <input
    type="text"
    matInput
    [formControl]="fc"
    [matAutocomplete]="autocomplete"
    placeholder="{{ label }}"
    [readonly]="readonly"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />
  <button
    type="button"
    [ngClass]="{ hide: !fc.value || readonly }"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="valueClear()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <mat-autocomplete
    #autocomplete="matAutocomplete"
    [displayWith]="autocompleteDisplayWith"
    (optionSelected)="autocompleteOptionSelected.emit($event.option.value)"
  >
    <ng-container *ngFor="let option of optionsFiltered | async">
      <mat-option [value]="option" (mousedown)="$event.preventDefault()">
        <span>{{ optionLabel(option) }}</span>
      </mat-option>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
